@if (mode === 'monochromatic-light') {
  <img src="logo-monochromatic-light.webp" alt="Collectoria Logo" [height]="height">
} @else {
  <img src="logo-default.webp" alt="Collectoria Logo" [height]="height">
}
